var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useMemo, useState, } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { signInService } from "../services/signInService";
import { forgotPasswordService, forgotResetPasswordService, } from "../services/forgotService";
import { verifyAccountTypeService, verifyAccountPasswordService, } from "../services/verifyAccountService";
import { getRecaptcha } from "../services/recaptchaService";
import { ValidateEmail } from "../utils/validations";
import { populateInsiderObjectUser } from "../services/insiderService";
export var AuthContext = createContext({});
export function AuthProvider(_a) {
    var _this = this;
    var children = _a.children;
    var navigate = useNavigate();
    var _b = __read(useSearchParams(), 1), searchParams = _b[0];
    var isLoyaltyOrigin = searchParams.get("referer");
    var loyaltyCheckStorage = localStorage.getItem("isLoyalty");
    if (isLoyaltyOrigin !== null) {
        localStorage.setItem("isLoyalty", "true");
    }
    else {
        localStorage.removeItem("isLoyalty");
    }
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    var _d = __read(useState(""), 2), erroHandler = _d[0], setErroHandler = _d[1];
    var _e = __read(useState(0), 2), numberOfAttempts = _e[0], setNumberOfAttempts = _e[1];
    var _f = __read(useState(0), 2), verifyAccountType = _f[0], setVerifyAccountType = _f[1];
    var _g = __read(useState(false), 2), isRetriesLeft = _g[0], setIsRetriesLeft = _g[1];
    var _h = __read(useState(null), 2), urlCallback = _h[0], setUrlCallback = _h[1];
    var clientIdTag = document.querySelector('meta[name="client-id"]');
    var clientId = clientIdTag ? clientIdTag.getAttribute("content") : "";
    var listLoyaltyClients = String(process.env.MIX_CLIENT_ID_LOYALTY).split(",");
    var isLoyalty = listLoyaltyClients.includes(clientId !== null && clientId !== void 0 ? clientId : "");
    var isFidelity = useMemo(function () { return isLoyalty || !!isLoyaltyOrigin || loyaltyCheckStorage === "true"; }, [clientId, process.env.MIX_CLIENT_ID_LOYALTY]);
    var handleCleanLoyaltyLocalStorage = useCallback(function () {
        localStorage.removeItem("isLoyalty");
    }, []);
    var handleErrorMessage = function (error, numberOfAttempts) {
        var _a, _b;
        if (axios.isAxiosError(error)) {
            var response = error.response;
            if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message.includes("captcha")) {
                setErroHandler("Erro ao validar captcha, tente novamente.");
            }
            else {
                setErroHandler((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message);
            }
        }
    };
    var onSignIn = useCallback(function (login, password, isFidelity) { return __awaiter(_this, void 0, void 0, function () {
        var recaptcha, _a, url_callback, type, error_1, response;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setLoading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 5, 6, 7]);
                    return [4 /*yield*/, getRecaptcha("login", numberOfAttempts)];
                case 2:
                    recaptcha = _c.sent();
                    return [4 /*yield*/, signInService(__assign({ login: login, password: password, isFidelity: isFidelity }, recaptcha))];
                case 3:
                    _a = _c.sent(), url_callback = _a.url_callback, type = _a.type;
                    return [4 /*yield*/, ValidateEmail(login)];
                case 4:
                    if (_c.sent()) {
                        populateInsiderObjectUser({
                            email: login,
                        });
                    }
                    else {
                        populateInsiderObjectUser({
                            custom: {
                                cpf: login,
                            },
                        });
                    }
                    setNumberOfAttempts(0);
                    if (isFidelity && type && type === 2) {
                        setVerifyAccountType(type);
                        navigate("/cadastro/autenticacao");
                        setUrlCallback(url_callback);
                    }
                    else {
                        window.open(url_callback, "_self");
                    }
                    return [3 /*break*/, 7];
                case 5:
                    error_1 = _c.sent();
                    setLoading(false);
                    if (axios.isAxiosError(error_1)) {
                        response = error_1.response;
                        setIsRetriesLeft(((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.retries_left) === 1);
                        handleErrorMessage(error_1, numberOfAttempts);
                    }
                    return [3 /*break*/, 7];
                case 6:
                    setNumberOfAttempts(function (prevState) { return prevState + 1; });
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); }, [numberOfAttempts]);
    var onForgotPassword = useCallback(function (login) { return __awaiter(_this, void 0, void 0, function () {
        var recaptcha, email_masked, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, getRecaptcha("forgot", numberOfAttempts)];
                case 2:
                    recaptcha = _a.sent();
                    return [4 /*yield*/, forgotPasswordService(__assign({ login: login, type: "reset" }, recaptcha))];
                case 3:
                    email_masked = (_a.sent()).email_masked;
                    setNumberOfAttempts(0);
                    navigate("/senha/email/sucesso", {
                        replace: true,
                        state: {
                            email_masked: email_masked,
                            login: login,
                        },
                    });
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _a.sent();
                    if (axios.isAxiosError(error_2)) {
                        handleErrorMessage(error_2, numberOfAttempts);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    setNumberOfAttempts(function (prevState) { return prevState + 1; });
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [numberOfAttempts]);
    var onResendEmail = useCallback(function (login) { return __awaiter(_this, void 0, void 0, function () {
        var recaptcha, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setErroHandler("");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, getRecaptcha("resendEmailForgot", numberOfAttempts)];
                case 2:
                    recaptcha = _a.sent();
                    return [4 /*yield*/, forgotPasswordService(__assign({ login: login, type: "reset" }, recaptcha))];
                case 3:
                    _a.sent();
                    setNumberOfAttempts(0);
                    return [3 /*break*/, 6];
                case 4:
                    error_3 = _a.sent();
                    if (axios.isAxiosError(error_3)) {
                        handleErrorMessage(error_3, numberOfAttempts);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    setNumberOfAttempts(function (prevState) { return prevState + 1; });
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [numberOfAttempts]);
    var onResetPassword = useCallback(function (params) { return __awaiter(_this, void 0, void 0, function () {
        var recaptcha, error_4, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setErroHandler("");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, getRecaptcha("newPassword", numberOfAttempts)];
                case 2:
                    recaptcha = _a.sent();
                    return [4 /*yield*/, forgotResetPasswordService(__assign(__assign(__assign({}, params), { type: "reset" }), recaptcha))];
                case 3:
                    _a.sent();
                    setNumberOfAttempts(0);
                    navigate("/senha/resetar/sucesso", {
                        replace: true,
                        state: true,
                    });
                    return [3 /*break*/, 6];
                case 4:
                    error_4 = _a.sent();
                    if (axios.isAxiosError(error_4)) {
                        response = error_4.response;
                        if ((response === null || response === void 0 ? void 0 : response.status) === 404) {
                            navigate("/erro/401", { replace: true });
                        }
                        else {
                            handleErrorMessage(error_4, numberOfAttempts);
                        }
                    }
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    setNumberOfAttempts(function (prevState) { return prevState + 1; });
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [numberOfAttempts]);
    var onVerifyAccount = useCallback(function (document) { return __awaiter(_this, void 0, void 0, function () {
        var recaptcha, _a, account_type, no_profile, error_5;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, getRecaptcha("cadastro", numberOfAttempts)];
                case 2:
                    recaptcha = _b.sent();
                    return [4 /*yield*/, verifyAccountTypeService(__assign({ document: document }, recaptcha))];
                case 3:
                    _a = _b.sent(), account_type = _a.account_type, no_profile = _a.no_profile;
                    setNumberOfAttempts(0);
                    setVerifyAccountType(Number(account_type));
                    return [3 /*break*/, 6];
                case 4:
                    error_5 = _b.sent();
                    if (axios.isAxiosError(error_5)) {
                        handleErrorMessage(error_5, numberOfAttempts);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    setNumberOfAttempts(function (prevState) { return prevState + 1; });
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [numberOfAttempts]);
    var onVerifyAccountPassword = useCallback(function (password) { return __awaiter(_this, void 0, void 0, function () {
        var url_callback, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, verifyAccountPasswordService({
                            password: password,
                        })];
                case 2:
                    url_callback = (_a.sent()).url_callback;
                    window.open(url_callback, "_self");
                    return [3 /*break*/, 5];
                case 3:
                    error_6 = _a.sent();
                    if (axios.isAxiosError(error_6)) {
                        handleErrorMessage(error_6, numberOfAttempts);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [numberOfAttempts]);
    var onDimissRetriesLeftToast = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setIsRetriesLeft(false);
            return [2 /*return*/];
        });
    }); }, [numberOfAttempts]);
    return (_jsx(AuthContext.Provider, __assign({ value: {
            loading: loading,
            erroHandler: erroHandler,
            numberOfAttempts: numberOfAttempts,
            urlCallback: urlCallback,
            isFidelity: isFidelity,
            handleCleanLoyaltyLocalStorage: handleCleanLoyaltyLocalStorage,
            verifyAccountType: verifyAccountType,
            isRetriesLeft: isRetriesLeft,
            setErroHandler: setErroHandler,
            onDimissRetriesLeftToast: onDimissRetriesLeftToast,
            onSignIn: onSignIn,
            onForgotPassword: onForgotPassword,
            onResendEmail: onResendEmail,
            onResetPassword: onResetPassword,
            isLoyaltyOrigin: isLoyaltyOrigin,
            onVerifyAccount: onVerifyAccount,
            onVerifyAccountPassword: onVerifyAccountPassword,
        } }, { children: children })));
}
